import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { ApiParameter } from '@blaze-shared/api-contracts-domain';
import { ButtonIconComponent } from '@blaze-shared/shared-ui';

import { ParametersForm } from '../api-builder.model';
import { updateDynamicFormControls } from '../utils/api-builder-utils';

@Component({
  selector: 'blaze-parameters-list',
  imports: [ButtonIconComponent, FormsModule, MatIconModule, ReactiveFormsModule],
  templateUrl: './parameters-list.component.html',
  styleUrls: ['./parameters-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParametersListComponent implements OnInit, OnChanges {
  @Input() label = '';
  @Input() formCtrl!: FormArray<FormGroup<ParametersForm>>;
  @Input() parameters: ApiParameter[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['parameters']) {
      return;
    }
    const params: ApiParameter[] = changes['parameters'].currentValue;

    if (!this.formCtrl) {
      return;
    }
    this.updateForm(this.formCtrl, params);
  }

  ngOnInit(): void {
    this.updateForm(this.formCtrl, this.parameters);
  }

  updateForm(form: FormArray, params: ApiParameter[]): void {
    updateDynamicFormControls(form, params, (param) => {
      const { name = '', value = '' } = param || {};
      return new FormGroup({
        name: new FormControl(name, { nonNullable: true }),
        value: new FormControl(value, { nonNullable: true }),
      });
    });
  }

  deleteParam(row: number): void {
    if (this.formCtrl.controls.length > 1) {
      this.formCtrl.removeAt(row);
    }
  }
}
